import { Row, Col } from 'antd';
import AnomalyAlertsChart from './AnomalyAlertCard';
import VehicleStatusChart from './VehicleStatusCard';
import DriverDrowsinessCard from './DriverDrowsinessCard';
import { ErrorMessageContext } from '../../context/ErrorMessageContext';
import { useContext, useRef, useState } from 'react';
import { API } from '../../services';
import useApiPolling from '../../hooks/useApiPolling';
import { getErrorMessage } from '../../utilities/commonFunctions';

const OverviewCards = () => {
  const isFirstCall = useRef(true);
  const { addErrorMessage } = useContext(ErrorMessageContext);
  const [anomalyData, setAnomalyData] = useState(null);
  const [anomalyChartLoading, setAnomalyChartLoading] = useState(true);

  const getAnomalyAlertsChartData = async () => {
    setAnomalyChartLoading(isFirstCall.current && true);
    try {
      const { data } = await API.getAnomalyAlertsChartData(false, true);
      setAnomalyData(data?.anomaly_counts);
    } catch (error) {
      if (isFirstCall.current) {
        addErrorMessage(
          getErrorMessage(
            error,
            'Unable to fetch anomaly alerts data! Please try again after sometime.'
          )
        );
      }
    } finally {
      isFirstCall.current = false;
      setAnomalyChartLoading(false);
    }
  };

  useApiPolling(getAnomalyAlertsChartData);

  return (
    <Row gutter={[16, 16]}>
      <Col xs={24} lg={6} className="overview-chart-spinner">
        <VehicleStatusChart />
      </Col>
      <Col xs={24} lg={9} className="overview-chart-spinner">
        <DriverDrowsinessCard
          anomalyData={anomalyData}
          anomalyChartLoading={anomalyChartLoading}
        />
      </Col>
      <Col xs={24} lg={9} className="overview-chart-spinner">
        <AnomalyAlertsChart
          anomalyData={anomalyData}
          anomalyChartLoading={anomalyChartLoading}
        />
      </Col>
    </Row>
  );
};

export default OverviewCards;
